module.exports = __webpack_public_path__ + "static/3c36c445747f11141808e30eeac5fa558d2abf97da367936f18ae9d124c9ccc1-bc7d23e3d5c288c7ef9b82648415e86d.png";